module.exports = {
  language: 'English',
  applierApplicationCenter: {
    selectCenterTip: 'Select this centre'
  },
  multiplePage: {
    moreInfomation: 'More information',
    recommendedServices: 'Recommended Services'
  },
  checkoutConfirm: {
    ordered: 'Ordered',
    purchased: 'Purchased'
  },
  personal: {
    purgePopupContent: 'Sorry, your application has been purged due to security policy, you may contact us if you want to apply soon.'
  },
  login_maximum: {
    errorContent: 'Sorry you have reached the maximum login times today, please try the next day.'
  },
  nationalityKay: 'hu-hu',
  noneSelectedText: 'Please select',
  enter: 'Enter',
  upload_failed: 'Upload failed, please retry',
  due_time: 'Due time',
  requirement: 'Requirement',
  valid_rediret_home_page_popup_content:
    "Bejelentkezési kivétel történt. A [ {country} - {center} ] honlapra próbálsz belépni, hogy bejelentkezz? Ha igen, kérjük, kattintson a 'Megerősítés' gombra; ha nem, kérjük, kattintson a 'Mégsem' gombra, hogy újra kiválaszthassa.",
  invalid_rediret_home_page_popup_content: 'Bejelentkezési kivétel történt, kérjük, válassza ki az országot és a helyszínt a folytatáshoz.',
  'Temporarily not available': 'Temporarily not available',
  'Coming soon': 'Coming soon'
};
